import { Pipe, PipeTransform } from '@angular/core';

/*
 * Format string
 * Usage:
 *   value | formatString
 *   value | formatString:limit
 * Example:
 *   {{ 'hello world!' | formatString:3 }}
 *   formats to: hel
 */
@Pipe({
    name: 'formatString',
    standalone: false
})
export class FormatStringPipe implements PipeTransform {
  transform(value: string, limit = 60): string {
    if (!value) {
      return value;
    }
    const str = String(value);
    if (str.length > limit) {
      return String(value).slice(0, limit) + '…';
    } else {
      return str;
    }
  }
}
